module.exports = __webpack_public_path__ + "static/media/pesquisar.6e15dde2.svg";